import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { slideInAnimation } from '../app-animation';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { MustMatch } from '../_helpers/MustMatch';
import { AuthenticationService } from '../_services/authentication.service';
import { Router, ActivatedRoute } from '@angular/router';
import * as CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment';
import { AmplifyService } from 'aws-amplify-angular';
import { MessageService } from '../_services/message.service';
import { ProductoService } from '../_services/producto.service';

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./sign-up.component.css'],
  animations: [slideInAnimation],
})
export class SignUpComponent implements OnInit {

  public RegisterForm: FormGroup;
  public emailExist = false;
  public errorMessage: string;
  public exitoso = false;
  public idAplicacion: string;

  constructor(private formBuilder: FormBuilder,
              private authService: AuthenticationService,
              private route: ActivatedRoute,
              private router: Router,
              private amplifyService: AmplifyService,
              private messageService: MessageService,
              private productoService: ProductoService) {

  }

  ngOnInit(): void {
    const maxLength = Validators.minLength(6);
    this.RegisterForm = this.formBuilder.group({
      nombre_asociado: ['', Validators.required],
      apellido_asociado: ['', Validators.required],
      email_asociado: ['', [Validators.required, Validators.email, Validators.pattern(/^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/)]],
      confirmemail_asociado: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, maxLength]],
      confirmpassword: ['', [Validators.required, maxLength]],
      captcha: ['', [Validators.required, maxLength]]
      // codigoArea: ['56'],
      // telefono: [undefined, [Validators.required, Validators.pattern(/([2-9])(\d{4})(\d{4})\D*/), Validators.minLength(9), Validators.maxLength(11)]],
      // accept_termsandconditions: [false, [Validators.required]]
    }, {
      validator: [
        MustMatch('email_asociado', 'confirmemail_asociado'),
        MustMatch('password', 'confirmpassword')
      ]
    });
    this.route.params.subscribe(par => {
      this.idAplicacion = par.idAplicacion
    });
  }

  socialSignIn() {
    this.productoService.setLoginParams(this.idAplicacion, undefined, undefined);
    const amplifyAuth: any = this.amplifyService.auth();
    amplifyAuth.federatedSignIn({
      provider: 'Google'
    });
  }

  finishRegister() {
    this.exitoso = true;
    this.authService.signUp(this.RegisterForm.value.nombre_asociado, this.RegisterForm.value.apellido_asociado,
      this.RegisterForm.value.email_asociado, this.RegisterForm.value.password).subscribe(data => {
        const encripted = CryptoJS.AES.encrypt(this.RegisterForm.value.email_asociado + '|' + this.RegisterForm.value.password, environment.encodeKey).toString().split('/').join();
        this.router.navigate(['/verification', this.idAplicacion, encripted]);
      }, error => {
        switch (error.status){
          case 409:
              if (error.error == 'Usuario ya existe'){
                this.messageService.sendMessage('Información',
                'Ya tenemos una cuenta con el correo <strong>' + this.RegisterForm.value.email_asociado + '</strong>. </br>' +
                'Favor inicia sesión para completar el proceso.',
                0,
                'info');
                this.router.navigate(['/login', this.idAplicacion]);
              }else{
                this.messageService.sendMessage('Error', error.error, 0, 'danger');
              }
              break;
          default:
            this.messageService.sendErrorMessage();
        }
      });
  }

  ngOnDestroy() {
    // this.authenticationService.logoutRegister();
  }
}
